import header from './header';
import footer from './footer';
import loginAndSignUp from './loginAndSignUp';
import profile from './personalCenter/profile';
import history from './personalCenter/history';
import setting from './personalCenter/setting';
import siderBar from './personalCenter/siderBar';
import common from './common';
import purchase from './purchase';
import backgroundRemover from './toolsPurchase/backgroundRemover';
import dynamicPhoto from './toolsPurchase/dynamicPhoto';
import photoEnhancer from './toolsPurchase/photoEnhancer';
import removeTTWaterMark from './toolsPurchase/removeTTWatermark';
import removeWaterMark from './toolsPurchase/removeWatermark';
import videoEnhancer from './toolsPurchase/videoEnhancer';
import upgradePersonal from './upgradePersonal';
const lang = {
  header: {
    ...header,
  },
  footer: {
    ...footer,
  },
  loginAndSignUp: {
    ...loginAndSignUp,
  },
  personalCenterSiderBar: {
    ...siderBar,
  },
  personalCenterProfile: {
    ...profile,
  },
  personalCenterHistory: {
    ...history,
  },
  personalCenterSetting: {
    ...setting,
  },
  common: {
    ...common,
  },
  purchase: {
    ...purchase,
  },
  toolsPurchaseBackgroundRemover: {
    ...backgroundRemover,
  },
  toolsPurchaseDynamicPhoto: {
    ...dynamicPhoto,
  },
  toolsPurchasePhotoEnhancer: {
    ...photoEnhancer,
  },
  toolsPurchaseRemoveTTWaterMark: {
    ...removeTTWaterMark,
  },
  toolsPurchaseRemoveWaterMark: {
    ...removeWaterMark,
  },
  toolsPurchaseVideoEnhancer: {
    ...videoEnhancer,
  },
  upgradePersonal: {
    ...upgradePersonal,
  },
};

export default lang;
